import { QueryHookOptions, useLazyQuery } from '@apollo/client/react';

import AppModule from '../../../app/lib/AppModule';
import appManager from '@app/appManager';
import { getAbandonedCallsBadgeCountFilters } from '@pages/urgentfollowups/AbandonedCallsPage/utils/filters';
import {
  AbandonedCallFollowUpFilterInput,
  AbandonedCallsCountQuery,
  Exact,
  InputMaybe,
} from '@api/generated/graphql';
import { GET_ABANDONED_CALL_FOLLOW_UPS_COUNT_QUERY } from './data/count';

export type AbandonedCallsCountExecuteQueryOptions = QueryHookOptions<
  AbandonedCallsCountQuery,
  Exact<{
    filter?: InputMaybe<AbandonedCallFollowUpFilterInput>;
    take?: InputMaybe<number>;
  }>
>;

let executeQuery: (options?: AbandonedCallsCountExecuteQueryOptions) => void;

export function useAbandonedCallsCountQuery() {
  const [execute, queryResult] = useLazyQuery(
    GET_ABANDONED_CALL_FOLLOW_UPS_COUNT_QUERY,
    {
      fetchPolicy: 'network-only',
    },
  );

  executeQuery = execute;

  return {
    error: queryResult.error,
    previousCount: queryResult.previousData?.abandonedCallFollowUps?.totalCount,
    currentCount: queryResult.data?.abandonedCallFollowUps?.totalCount,
    execute: (options?: QueryHookOptions<AbandonedCallsCountQuery>) => {
      execute(options);
    },
  };
}

class AbandonedCallsModule extends AppModule {
  override events = ['abandonedcall.update'];

  override preload(): void {
    if (executeQuery === undefined) {
      this.app.logger.warn(
        'AbandonedCallsModule: executeQuery is undefined, ensure useAbandonedCallsCountQuery is called before this module is used.',
      );
    }
    this.app.events.on('abandonedcall.update', () => {
      this.app.logger.info('trigger ABCL refresh');
      executeQuery?.({
        variables: {
          filter: getAbandonedCallsBadgeCountFilters(),
          take: 1,
        },
      });
    });
  }
}

export default new AbandonedCallsModule(
  appManager.events,
  appManager.logger('AbandonedCallsCount'),
);
